<template>
  <scoped>
    <div class="modal">
      <div>
        <h1>
          {{ title }}
        </h1>
        <p>
          {{ message }}
        </p>
        <Button
          title="Close"
          @click="error = null"
        />
        <Button
          v-if="redirectSession"
          title="Session"
          @click="sessionRedirect()"
        />
      </div>
    </div>
  </scoped>
</template>

<script setup lang="ts">
  import {onBeforeMount, ref} from "vue"
  import Button from "@/components/button.vue"
  import {InvalidCredentialsError} from "@/endpoints/rutsolve/gql/errors/invalid_credentials"
  import {InvalidTokenError} from "@/endpoints/rutsolve/gql/errors/invalid_token"
  import {SuspendedError} from "@/endpoints/rutsolve/gql/errors/suspended"
  import {UnauthorizedError} from "@/endpoints/rutsolve/gql/errors/unauthorized"
  import router from "@/router"

  const error = defineModel("error", {
    default: null,
    required: true,
    type: Error
  })

  const redirectSession = ref<boolean>(false)
  const message = ref<string>(null)
  const title = ref<string>(null)

  onBeforeMount(() => {
    extractError()
  })

  function extractError() {
    message.value = error.value.message
    title.value = "Error"

    if (error.value instanceof InvalidCredentialsError) {
      message.value = "Invalid credentials."
      title.value = "Authentication Error"
    }

    if (error.value instanceof InvalidTokenError) {
      redirectSession.value = true
      message.value = "Invalid token."
      title.value = "Authentication Error"
    }

    if (error.value instanceof SuspendedError) {
      message.value = "Account suspended."
      title.value = "Authentication Error"
    }

    if (error.value instanceof UnauthorizedError) {
      redirectSession.value = true
      message.value = "No permission for this action."
      title.value = "Authorization Error"
    }
  }

  function sessionRedirect() {
    router.push({
      name: "session"
    })
  }
</script>

<style scoped>
  .modal {
    align-items: center;
    backdrop-filter: blur(5px);
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    height: 100vh;
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 1;

    > div {
      background-color: var(--color-white);
      border-color: var(--color-red);
      border-radius: var(--border-radius-big);
      border-style: solid;
      border-width: var(--border-width-bold);
      max-height: 80vh;
      max-width: 80vw;
      padding: 2em;
      z-index: 2;
    }
  }
</style>
